import "./runtime.js"

import * as React from "react"
import * as ReactDOM from "react-dom"
import App from "../modules/app/index.js"

if (module.hot) {
  module.hot.accept()
}

var mountNode = document.getElementById("react-cico")
ReactDOM.render(<App />, mountNode)
